export const initialAuthData = {
	email: "",
	password: "",
	name: "",
	errorMessage: "",
	encodedToken: "",
};
